// For someone without 2-step (rule `optional`): a quiet reminder on every page until they turn it on, with the way
// there. "Later" hides it until the next sign-in.
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { ROUTES } from '@/constants/routes'
import { useMe } from '../session'

export function TwoStepBanner() {
  const { user } = useMe()
  const [hidden, setHidden] = useState(false)
  if (user.two_step || hidden) return null
  return (
    <div
      className="mb-4 flex flex-wrap items-center gap-2 rounded border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200"
      data-testid="two-step-banner"
    >
      <ShieldAlert size={14} className="shrink-0" />
      <span className="flex-1">
        2-step sign-in is off for you. Turn it on: someone who learns your password still cannot sign in.
      </span>
      <Link to={ROUTES.account.to()} className="btn btn-primary btn-sm" data-testid="two-step-banner-go">
        Turn on
      </Link>
      <button type="button" className="btn btn-ghost btn-sm" onClick={() => setHidden(true)}>
        Later
      </button>
    </div>
  )
}
